import { useSelector } from 'react-redux';
import Text from '../../components/Text';
import { fontSizes } from '../../constants/constants';
import { getContentKeyAccToLang } from '../../utils/utils';
import dynamicfunction from '../../utils/dynamicfunction';
import ViewReverse from '../../components/ViewReverse';
import Button from '../../components/Button';
import { useNavigate } from 'react-router';

const ErrorForbidden = () => {
  const navigate = useNavigate();
  const { TextWeight, isArabic } = dynamicfunction();
  const { dashboardContent } = useSelector((state) => state.content);
  const getContentKey = (key) => {
    return getContentKeyAccToLang(dashboardContent, key, isArabic);
  };

  return (
    <ViewReverse className='flex flex-col h-[calc(100vh-88px)] max-w-2xl mx-auto items-center justify-center text-center -mt-[88px]'>
      <Text
        text={getContentKey('error_forbidden_heading')}
        size={fontSizes.h70}
        weight={TextWeight.bold}
        isTruncate={false}
        color='text-primary'
        className={'uppercase'}
      />
      <Text text={getContentKey('error_forbidden_description')} size={fontSizes.h16} isTruncate={false} color='text-silver' isCenter={true} />
      <Button
        text={getContentKey('go_to_homepage_btn')}
        bgColor='bg-primary'
        weight={TextWeight.light}
        className={'w-full rounded-lg capitalize py-2 mt-5'}
        onClick={() => {
          navigate('/funds/available-funds');
        }}
      />
    </ViewReverse>
  );
};
export default ErrorForbidden;
